<div class="top-container">
  <h3 class="h4">{{ product.product_name }}</h3>

  <ul class="feature-list">
    @for (attribute of product.attributes; track attribute.description + attribute.value) {
      <li class="feature-item" [ngClass]="{ 'feature-visible': attribute.description === 'product_feature' }">
        <span class="bullet-point"></span>
        <span class="feature-text">{{ attribute.value }}</span>
      </li>
    }
  </ul>
</div>

<div class="bottom-container">
  <div class="price">
    {{ toEur(product.price) }}
  </div>

  <div class="button-container">
    <app-button type="primary" text="Jetzt bestellen" routerLink="/kontakt" [ariaLabel]="'Jetzt ' + product.product_name + ' bestellen'">
    </app-button>
  </div>
</div>
